// extracted by mini-css-extract-plugin
export var content = "styles-module--content--2d9bb";
export var pageVariant = "styles-module--pageVariant--32f49";
export var wysiwyg = "styles-module--wysiwyg--e53cd";
export var wysiwygContainer = "styles-module--wysiwygContainer--e372f";